'use client';

import React from 'react';
import { openCookieSettings } from '@/lib/consent';

export default function CookieSettingsButton({ className }: { className?: string }) {
  return (
    <button data-component-id="src/components/CookieSettingsButton.tsx:8:4" data-component-path="src/components/CookieSettingsButton.tsx" data-component-line="8" data-component-end-line="10" data-component-file="CookieSettingsButton.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%2C%22textContent%22%3A%22Cookie%20settings%22%7D" type="button" onClick={openCookieSettings} className={className}>
      Cookie settings
    </button>
  );
}
